module.exports = __webpack_public_path__ + "static/media/mb2.a41ea35f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mb2.png
// module id = 199
// module chunks = 0